import ApiClient from '../../client';

export const state = () => {
  return {
    voucherBalance: null,
    dynamicVouchers: [],
    isVoucherBalanceLoading: true,
    isDynamicVoucherLoading: false
  };
};

export const getters = {
  getVoucherBalance: (state) => state.voucherBalance,
  getIsVoucherBalanceLoading: (state) => state.isVoucherBalanceLoading,

  getDynamicVouchers: (state) => state.dynamicVouchers,
  getIsDynamicVoucherLoading: (state) => state.isDynamicVoucherLoading
};

export const mutations = {
  setVoucherBalance(state, payload) {
    state.voucherBalance = payload;
  },

  setIsVoucherBalanceLoading(state, payload) {
    state.isVoucherBalanceLoading = payload;
  },

  setDynamicVouchers(state, payload) {
    state.dynamicVouchers = payload;
  },

  setIsDynamicVoucherLoading(state, payload) {
    state.isDynamicVoucherLoading = payload;
  }
};

export const actions = {
  async getVouchers({ commit, rootGetters }) {
    try {
      const userId = rootGetters['Authentication/getUser'].UserID;
      const response = await ApiClient.getVoucherBalance(userId);

      commit('setVoucherBalance', response.data?.voucherBalance);
      commit('setIsVoucherBalanceLoading', false);
    } catch (e) {
      console.error('Voucher balance threw exception', e);
      commit('setIsVoucherBalanceLoading', false);
    }
  },

  async getDynamicVoucherAsync(
    { commit, rootGetters },
    { registrationId, eventId }
  ) {
    try {
      commit('setIsDynamicVoucherLoading', true);

      const response = await ApiClient.getDynamicVoucherAsync(
        registrationId,
        eventId
      );

      commit('setDynamicVouchers', response.data);
    } catch (e) {
      console.error('Dynamic vouchers threw exception', e);
    } finally {
      commit('setIsDynamicVoucherLoading', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
